import { returnsApiProxy } from '@/redux/api/returns-api-slice'
import type { ReturnsApiSubmitWithdrawalRequest } from '@itsrever/rever-api'
import { useMutation } from '@tanstack/react-query'

const submitWithdrawal = async (req: ReturnsApiSubmitWithdrawalRequest) => {
  const { data } = await returnsApiProxy.submitWithdrawal(req)

  return data
}

export const useSubmitWithdrawal = () => {
  return useMutation({
    mutationFn: submitWithdrawal
  })
}
